import { render, staticRenderFns } from "./LessonsRating.vue?vue&type=template&id=2206dd24"
import script from "./LessonsRating.vue?vue&type=script&lang=js"
export * from "./LessonsRating.vue?vue&type=script&lang=js"
import style0 from "./LessonsRating.vue?vue&type=style&index=0&id=2206dd24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports